import React from 'react'
import { Compass, Ship, ArrowRight, MessageSquare } from 'lucide-react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Waves, Clock, Sparkles } from 'lucide-react';
import {  Anchor, Star } from 'lucide-react';
import {  MapPin } from 'lucide-react';

import {  Camera, Users, Sunset } from 'lucide-react';
import FAQSection from '../Components/FAQSection';

const alibaugElephantaFaqs = [
  {
    question: "What is an Alibaug boat tour from Mumbai like?",
    answer:
      "An Alibaug boat tour from Mumbai is a private sea journey that offers a faster, more scenic and more enjoyable way to reach Alibaug compared with regular city travel options."
  },
  {
    question: "What is an Elephanta boat tour from Mumbai like?",
    answer:
      "An Elephanta boat tour from Mumbai is a private island boat trip that feels scenic, comfortable and well suited for sightseeing, family outings and short cultural visits."
  },
  {
    question: "Why choose a private boat tour instead of regular travel?",
    answer:
      "A private boat tour avoids road traffic and crowded routes, while offering a more comfortable, scenic and premium travel experience."
  },
  {
    question: "Is a private boat tour suitable for families and small groups?",
    answer:
      "Yes. Private boat tours to Alibaug and Elephanta are ideal for families, couples and private groups who want a more comfortable and flexible outing."
  },
  {
    question: "Which destination is better for a quick getaway from Mumbai?",
    answer:
      "Alibaug is a popular choice for a relaxed coastal escape, while Elephanta is ideal for sightseeing and island visits. The best choice depends on the experience you want."
  },
  {
    question: "Can I use the boat as both a transfer and an experience?",
    answer:
      "Yes. Many guests choose private boat tours because the journey itself becomes a scenic and enjoyable part of the outing."
  },
  {
    question: "How is Indiaboats different for island boat tours?",
    answer:
      "Indiaboats focuses on premium private sea experiences and helps guests choose the right boat format for a smoother and more memorable trip."
  },
  {
    question:
      "How do I enquire about an Alibaug or Elephanta boat tour from Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, destination and group size."
  }
];


const Alibaug = () => {
const wteExperiencePoints = [
  "Premium private boat experience from Mumbai",
  "Guidance based on group size and destination",
  "Suitable options for Alibaug and Elephanta",
  "Scenic and comfortable sea journey",
  "Better alternative to city traffic and crowded routes",
  "Supportive and experience-led planning",
];

  const pfUniqueBoatExperiences = [
  "Alibaug boat tour from Mumbai",
  "Elephanta boat tour from Mumbai",
  "Private island getaway from Mumbai",
  "Family sightseeing boat trips",
  "Couples and small group coastal travel",
  "Weekend sea travel from Mumbai",
  "Premium private boat experiences",
];


// Data object defined inside the component body for better maintainability.
  const ibBoatSelectorData = {
    title: "Which Boat Option Is Right for Your Trip",
    primaryParagraph: "The right boat for an Alibaug or Elephanta tour depends mainly on your group size, comfort preference and travel style.",
    secondaryParagraph: "For smaller private groups, couples and families, a speed boat or compact private transfer option is usually ideal. For bigger groups or premium outings, a larger private boat option may be more suitable depending on the number of guests and the style of travel you want.",
    ctaText: "Explore Private Speed Boat Transfers from Mumbai"
  };

  // Unique SVG icons for professional, non-emoji aesthetic
  const LuxuryBoatIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#113d48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 18h20"/><path d="M14 18l1-4h-6l1 4"/><path d="M12 14V8l-3 4"/><path d="M12 8l3 4"/></svg>
  );
  const NavigationIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#113d48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
  );
  const QualityStarIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#113d48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
  );
  const PrivateGroupIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#113d48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  );
  const ScenicWavesIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#113d48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12c.5-1 1.5-1 2 0s1.5 1 2 0 1.5-1 2 0 1.5 1 2 0 1.5-1 2 0 1.5 1 2 0"/><path d="M2 16c.5-1 1.5-1 2 0s1.5 1 2 0 1.5-1 2 0 1.5 1 2 0 1.5-1 2 0 1.5 1 2 0"/><path d="M2 8c.5-1 1.5-1 2 0s1.5 1 2 0 1.5-1 2 0 1.5 1 2 0 1.5-1 2 0 1.5 1 2 0"/></svg>
  );
  const PlannerIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#113d48" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
  );

  // Unique data structure for project-safe variable naming
  const ibLuxuryFeaturePoints = [
    { title: "Private Charters", desc: "Exclusive, premium charters from Mumbai.", icon: <LuxuryBoatIcon /> },
    { title: "Seamless Transit", desc: "Direct access to Alibaug and Elephanta.", icon: <NavigationIcon /> },
    { title: "Superior Comfort", desc: "Faster, smoother, more luxurious.", icon: <QualityStarIcon /> },
    { title: "Tailored Experience", desc: "Perfect for couples and families.", icon: <PrivateGroupIcon /> },
    { title: "Scenic Journey", desc: "Breathtaking coastal experiences.", icon: <ScenicWavesIcon /> },
    { title: "Effortless Booking", desc: "Convenience-focused trip planning.", icon: <PlannerIcon /> }
  ];

     const activities = [
    { title: "Avoid Traffic", desc: "Enjoy a serene private sea ride, escaping the city's hustle." },
    { title: "Capture Memories", desc: "Take iconic photos of the Mumbai skyline and open water." },
    { title: "Island Escapes", desc: "Plan the perfect quick getaway with family or friends." },
    { title: "Travel in Style", desc: "Travel comfortably to Alibaug or the caves of Elephanta." },
    { title: "Premium Transit", desc: "A sophisticated alternative to regular, crowded routes." },
    { title: "Private Breeze", desc: "Experience fresh sea air exclusively with your own group." },
    { title: "Coastal Outings", desc: "Create a memorable, short-duration coastal excursion." },
    { title: "Leisure Voyages", desc: "Seamlessly combine your transport with a leisure experience." }
  ];

      const elephantaTourHighlights = [
    { title: "Sightseeing & Caves", desc: "Perfect for discovering the iconic cave temples and local island culture." },
    { title: "Group Friendly", desc: "Thoughtfully curated space and seating arrangements for comfortable group outings." },
    { title: "Flexible Routes", desc: "Tailor your departure times and cruise pace exactly to your schedule." },
    { title: "Exclusive Comfort", desc: "Avoid crowded public ferries with an exclusive, luxury-appointed private transfer." },
    { title: "Scenic Marine Views", desc: "Capture unforgettable skyline vistas of Mumbai from the pristine harbor." }
  ];

      const highlights = [
    { title: "Quick Escape", desc: "A rapid coastal getaway just minutes from Mumbai's shoreline." },
    { title: "Leisure Focus", desc: "Popular for premium weekend retreats and beachside leisure." },
    { title: "Scenic Comfort", desc: "A smooth, relaxing alternative to long, fatiguing road travel." },
    { title: "Private Settings", desc: "Exclusively designed for couples, families, and private groups." },
    { title: "Premium Transit", desc: "The ultimate standard for luxurious, private coastal movement." }
  ];
  return (
    <>
        <Header/>

          <div className="ib-page-wrapper">
             <div className="aeb-page-section-one">
      {/* 1. HERO HEADER */}
      <section className="aeb-hero">
        <div className="aeb-container">
          <div className="aeb-hero-grid">
            
            {/* Text Column */}
            <div className="aeb-hero-content">
              <span className="aeb-hero-badge">
                <Compass size={14} className="aeb-badge-icon" />
                Nautical Escapes
              </span>
              <h1 className="aeb-hero-title">
                Alibaug & Elephanta Boat Tours from Mumbai
              </h1>
              <p className="aeb-hero-subtext">
                Escape the city with quick island getaways and scenic boat experiences from Mumbai to Alibaug and Elephanta. Discover what the journey feels like, what to expect, and why private boat travel with Indiaboats is one of the most comfortable and memorable ways to explore Mumbai’s nearby coastal destinations.
              </p>
              
              <div className="aeb-hero-btn-stack">
                <a href="#plan" className="th-btn style3 th-icon">
                  Plan Your Boat Tour
                  <ArrowRight size={16} />
                </a>
                <a href="https://wa.me/917977600563" className="aeb-btn aeb-btn-whatsapp" target="_blank" rel="noopener noreferrer">
                  <MessageSquare size={16} fill="currentColor" />
                  Enquire on WhatsApp
                </a>
                <a href="#options" className="aeb-btn aeb-btn-secondary">
                  Explore Speed Boat Options
                </a>
              </div>
            </div>

            {/* Visual Column */}
            <div className="aeb-hero-media">
              <div className="aeb-image-frame">
                <img 
                  src="/assets/img/private-yacht-charter-mumbai-hero.png" 
                  alt="Premium Yacht sailing away from Gateway of India, Mumbai" 
                  className="aeb-media-img" 
                />
                <div className="aeb-floating-card">
                  <Ship size={20} className="aeb-floating-icon" />
                  <div>
                    <span className="aeb-floating-title">Premium Fleet Only</span>
                    <span className="aeb-floating-desc">Catering to comfort & style</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 2. TRUST STRIP */}
      <div className="aeb-trust-strip">
        <div className="aeb-container">
          <div className="aeb-trust-flex">
            <span className="aeb-trust-item">Alibaug Boat Tour Mumbai</span>
            <span className="aeb-trust-divider">|</span>
            <span className="aeb-trust-item">Elephanta Boat Tour Mumbai</span>
            <span className="aeb-trust-divider">|</span>
            <span className="aeb-trust-item">Private Boat Trips</span>
            <span className="aeb-trust-divider">|</span>
            <span className="aeb-trust-item">Island Getaways</span>
            <span className="aeb-trust-divider">|</span>
            <span className="aeb-trust-item">Premium Sea Travel</span>
          </div>
        </div>
      </div>

      {/* 3. ESCAPE INTRO DUO */}
      <section className="aeb-intro-section">
        <div className="aeb-container">
          <div className="aeb-intro-grid">
            
            <div className="aeb-intro-header-col">
              <span className="aeb-section-tag">THE EXPERIENCE</span>
              <h2 className="aeb-intro-title">
                Escape Mumbai with a Private Boat Tour
              </h2>
              <div className="aeb-title-accent"></div>
            </div>

            <div className="aeb-intro-body-col">
              <p className="aeb-intro-paragraph">
                An Alibaug or Elephanta boat tour from Mumbai is one of the best ways to step away from the city and experience the coast in a faster, more scenic and more enjoyable way. Instead of spending time in traffic or relying on crowded travel routes, a private boat trip gives you a smoother and more memorable journey on the water.
              </p>
              <p className="aeb-intro-paragraph">
                Whether you are planning a quick island getaway, a family outing, a private sightseeing experience or a premium sea transfer, boat tours to Alibaug and Elephanta offer a refreshing alternative to regular travel. The journey itself becomes part of the experience, with sea breeze, skyline views and a far more relaxed atmosphere.
              </p>
              <p className="aeb-intro-paragraph aeb-highlight-text">
                With Indiaboats, private boat tours from Mumbai feel more premium, more convenient and more experience-led from the start.
              </p>
            </div>

          </div>
        </div>
      </section>
      </div>

 <section className="aeb-better-section">
      <div className="aeb-container">
        <div className="aeb-better-grid">
          
          {/* Left Content Side */}
          <div className="aeb-better-content-col">
            <span className="aeb-section-tag">COMPARED TO REGULAR TRANSIT</span>
            <h2 className="aeb-better-section-title">
              Why a Private Boat Tour Feels Better Than Regular Travel
            </h2>
            
            <div className="aeb-better-paragraphs">
              <p className="aeb-better-p">
                A private boat tour feels special because the travel itself becomes enjoyable. You are not just trying to reach a destination — you are already in the experience from the moment you leave the city shoreline.
              </p>
              <p className="aeb-better-p">
                There is no road congestion, no crowded terminals and no routine travel fatigue. Instead, you enjoy open sea views, a more direct route and a private setting with your own group. This makes Alibaug and Elephanta feel more accessible, more scenic and much more enjoyable to visit.
              </p>
              <p className="aeb-better-p">
                For families, couples and private groups, the difference is immediate. The trip feels less like transport and more like a premium coastal outing.
              </p>
            </div>

            {/* Callout Highlight Block */}
            <div className="aeb-highlight-banner">
              <Sparkles className="aeb-highlight-icon" size={24} />
              <p className="aeb-highlight-banner-text">
                Skip the traffic. Explore Mumbai’s best islands in style.
              </p>
            </div>
          </div>

          {/* Right Interactive/Feature Side */}
          <div className="aeb-better-features-col">
            <div className="aeb-feature-visual-card">
              <img 
                src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&q=80&w=1200" 
                alt="Private luxury speedboat on open sea with wake" 
                className="aeb-feature-img"
              />
              
              <div className="aeb-amenities-stack">
                <div className="aeb-amenity-pill">
                  <Waves className="aeb-pill-svg" size={16} />
                  <span>No Road Congestion</span>
                </div>
                <div className="aeb-amenity-pill">
                  <Clock className="aeb-pill-svg" size={16} />
                  <span>Direct Open Water Routes</span>
                </div>
                <div className="aeb-amenity-pill">
                  <Compass className="aeb-pill-svg" size={16} />
                  <span>Exclusive Group Setting</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      </section>

       <section className="abt-main-section">
      <div className="abt-container">
        
        {/* Top Split Section - Image and Description aligned to the same height */}
        <div className="abt-top-split-grid">
          
          {/* Left Side: Premium Visual Showcase */}
          <div className="abt-visual-column">
            <div className="abt-image-wrapper">
              <div className="abt-image-border-inset"></div>
              <img 
               src="https://images.unsplash.com/photo-1548574505-5e239809ee19?auto=format&fit=crop&w=1200&q=80"
                alt="Luxury yacht cruising along the coastal waters of Mumbai to Alibaug" 
                className="abt-main-img" 
              />
              <div className="abt-floating-badge">
                <div className="abt-badge-icon-box">
                  <Anchor size={18} />
                </div>
                <div className="abt-badge-content">
                  <span className="abt-badge-title">20 MINS</span>
                  <span className="abt-badge-subtitle">Express Crossing</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Elegant Editorial Content */}
          <div className="abt-content-column">
            <div className="abt-header-group">
              <div className="abt-tag-wrapper">
                <Compass size={12} className="abt-compass-icon" />
                <span className="abt-pre-title">Curated Destinations</span>
              </div>
              <h2 className="abt-section-title">Alibaug Boat Tours <span className="abt-light-text">from Mumbai</span></h2>
            </div>
            
            <div className="abt-paragraphs">
              <p className="abt-p">
                A private boat tour from Mumbai to Alibaug is ideal for guests looking for a quick coastal escape, a weekend outing or a premium sea journey to one of the region’s most popular destinations. Alibaug is known for its beachside atmosphere, holiday feel and relaxed pace, making it a favourite option for short getaways from Mumbai.
              </p>
              <p className="abt-p">
                A private Alibaug boat tour is especially useful for families, small groups and travellers who value convenience, privacy and a better travel experience. Instead of the longer road route, the sea journey feels faster, more scenic and more enjoyable.
              </p>
            </div>

            {/* Booking Trigger */}
            <button className="abt-cta-btn">
              <span>Enquire Alibaug Charters</span>
              <div className="abt-btn-arrow-box">
                <ArrowRight size={14} />
              </div>
            </button>
          </div>

        </div>

        {/* Bottom Section: Side-by-side Highlights Deck spanning full width with premium dark cards */}
        <div className="abt-bottom-highlights-section">
          <div className="abt-deck-header">
            <Star size={14} className="abt-star-icon" />
            <h4 className="abt-highlights-title">Alibaug Highlights</h4>
          </div>
          
          <div className="abt-highlights-horizontal-grid">
            {highlights.map((item, index) => (
              <div key={index} className="abt-highlight-card">
                <div className="abt-card-top-accent"></div>
                <div className="abt-card-header-row">
                  <span className="abt-card-num">0{index + 1}</span>
                  <h5 className="abt-card-title">{item.title}</h5>
                </div>
                <p className="abt-card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
      </section>

      <section className="ebt-main-section">
      <div className="ebt-container">
        
        {/* Top Split Section - Image and Description aligned to the same height */}
        <div className="ebt-top-split-grid">
          
          {/* Left Side: Elegant Editorial Content */}
          <div className="ebt-content-column">
            <div className="ebt-header-group">
              <div className="ebt-tag-wrapper">
                <MapPin size={12} className="ebt-map-icon" />
                <span className="ebt-pre-title">Cultural Journeys</span>
              </div>
              <h2 className="ebt-section-title">
                Elephanta Boat Tours <span className="ebt-light-text">from Mumbai</span>
              </h2>
            </div>
            
            <div className="ebt-paragraphs">
              <p className="ebt-p">
                A private boat tour from Mumbai to Elephanta is perfect for guests who want a scenic and comfortable route to one of Mumbai’s most iconic island destinations. Elephanta is popular for sightseeing, cultural visits and short island experiences, making it ideal for families, visitors and private groups looking for a memorable outing.
              </p>
              <p className="ebt-p">
                A private Elephanta boat trip offers more flexibility and comfort than routine travel options. The journey feels calmer, more private and better suited to guests who want to enjoy the sea while reaching the island in a more premium way.
              </p>
            </div>

            {/* Booking Trigger */}
            <button className="ebt-cta-btn">
              <span>Explore Elephanta Charters</span>
              <div className="ebt-btn-arrow-box">
                <ArrowRight size={14} />
              </div>
            </button>
          </div>

          {/* Right Side: Premium Visual Showcase with Offset Frame */}
          <div className="ebt-visual-column">
            <div className="ebt-image-wrapper">
              <div className="ebt-image-border-inset"></div>
              <img 
                src="https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&w=1200&q=80" 
                alt="Luxury speed boat docked near a scenic coastal island" 
                className="ebt-main-img" 
              />
              <div className="ebt-floating-badge">
                <div className="ebt-badge-icon-box">
                  <Anchor size={18} />
                </div>
                <div className="ebt-badge-content">
                  <span className="ebt-badge-title">BESPOKE ROUTE</span>
                  <span className="ebt-badge-subtitle">Scenic Sightseeing</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Section: Side-by-side Highlights Deck spanning full width with premium dark cards */}
        <div className="ebt-bottom-highlights-section">
          <div className="ebt-deck-header">
            <Star size={14} className="ebt-star-icon" />
            <h4 className="ebt-highlights-title">Elephanta Highlights</h4>
          </div>
          
          <div className="ebt-highlights-horizontal-grid">
            {elephantaTourHighlights.map((item, index) => (
              <div key={index} className="ebt-highlight-card">
                <div className="ebt-card-top-accent"></div>
                <div className="ebt-card-header-row">
                  <span className="ebt-card-num">0{index + 1}</span>
                  <h5 className="ebt-card-title">{item.title}</h5>
                </div>
                <p className="ebt-card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
      </section>

      <section className="tds-main-section">
      <div className="tds-container">
        
        {/* Top Section - Split Header and Intro */}
        <div className="tds-top-split-grid">
          <div className="tds-content-column">
            <div className="tds-tag-wrapper">
              <Waves size={12} className="tds-icon" />
              <span className="tds-pre-title">Experience More</span>
            </div>
            <h2 className="tds-section-title">
              Things to Do During an <span className="tds-light-text">Alibaug or Elephanta Boat Tour</span>
            </h2>
          </div>
          
          <div className="tds-intro-column">
            <p className="tds-p">
              A private boat tour from Mumbai is far more than just a simple transfer. Depending on your route and group, the journey itself becomes a significant part of the experience, offering a uniquely scenic outing on the Arabian Sea.
            </p>
          </div>
        </div>

        {/* Bottom Section - 8-Item Highlights Grid */}
        <div className="tds-highlights-grid">
          {activities.map((item, index) => (
            <div key={index} className="tds-card">
              <div className="tds-card-top-accent"></div>
              <div className="tds-card-icon-box">
                {index % 4 === 0 && <Ship size={20} />}
                {index % 4 === 1 && <Camera size={20} />}
                {index % 4 === 2 && <Users size={20} />}
                {index % 4 === 3 && <Sunset size={20} />}
              </div>
              <h5 className="tds-card-title">{item.title}</h5>
              <p className="tds-card-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
      </section>

       <section className="exp-section">
      <div className="exp-container">
        
        {/* Section Header */}
        <div className="exp-header">
          <h2 className="exp-title">What the Experience Feels Like</h2>
          <div className="exp-divider"></div>
        </div>

        {/* Main Content Grid */}
        <div className="exp-content">
          <p className="exp-main-text">
            An Alibaug or Elephanta boat tour feels fresh, scenic, and more enjoyable than conventional city travel. 
            As soon as you leave the shore, the mood changes. The air feels lighter, the surroundings feel more 
            open, and the journey becomes something you actually enjoy rather than simply complete.
          </p>

          <div className="exp-sub-grid">
            <div className="exp-card">
              <h4 className="exp-card-title">Alibaug</h4>
              <p className="exp-card-text">
                Feels like a quick escape from Mumbai into a more relaxed, serene coastal atmosphere.
              </p>
            </div>
            <div className="exp-card">
              <h4 className="exp-card-title">Elephanta</h4>
              <p className="exp-card-text">
                Feels like a culturally rich island outing, elevated by the exclusivity of a private ride.
              </p>
            </div>
          </div>

          <p className="exp-footer">
            With <strong>Indiaboats</strong>, the focus is on making the boat tour feel smooth, 
            comfortable, and memorable from departure to arrival.
          </p>
        </div>
      </div>
      </section>

      <section className="ib-luxury-feature-wrapper">
        <div className="ib-luxury-feature-container">
        <div className="ib-luxury-feature-main-content">
          <h2 className="ib-luxury-feature-headline">
            Why Choose <span className="ib-luxury-feature-text-accent">Indiaboats</span> for <span className="ib-luxury-feature-text-accent">Alibaug</span> & <span className="ib-luxury-feature-text-accent">Elephanta</span>
          </h2>
          <p>
            <span className="ib-luxury-feature-text-accent">Indiaboats</span> provides premium private boat experiences from Mumbai, helping guests navigate <span className="ib-luxury-feature-text-accent">Alibaug</span> and <span className="ib-luxury-feature-text-accent">Elephanta</span> with greater comfort and ease.
          </p>
          <p>We believe travel should be seamless. From family outings to island excursions, we ensure your sea journey is the highlight of your day.</p>
        </div>

        <div className="ib-luxury-feature-grid">
          {ibLuxuryFeaturePoints.map((item, index) => (
            <div key={index} className="ib-luxury-feature-card">
              <div className="ib-luxury-feature-icon-box">{item.icon}</div>
              <div className="ib-luxury-feature-card-content">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

      <section className="ib-boat-selector-wrapper">

      <div className="ib-boat-selector-container">
        <h2 className="ib-boat-selector-headline">{ibBoatSelectorData.title}</h2>
        <p className="ib-boat-selector-text">{ibBoatSelectorData.primaryParagraph}</p>
        <p className="ib-boat-selector-text">{ibBoatSelectorData.secondaryParagraph}</p>

        <a href="#" className="ib-boat-selector-cta-block">
          <span className="ib-boat-selector-cta-text">{ibBoatSelectorData.ctaText}</span>
          <svg className="ib-boat-selector-icon" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </div>
    </section>

     <section className="pfUniqueMainSection">
      <div className="pfUniqueContainer">
       

        <h2 className="pfUniqueHeading">
          Perfect <span>For</span>
        </h2>

        <div className="pfUniqueGridWrapper">
          {pfUniqueBoatExperiences.map((item, index) => (
            <div className="pfUniqueCardBox" key={index}>
              <div className="pfUniqueCheckIcon">✓</div>

              <p className="pfUniqueCardText">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

      <section className="wteUniqueMainSection">
      <div className="wteUniqueContainer">
        <div className="wteUniqueContentWrapper">
          <div className="wteUniqueLeftContent">
            <span className="wteUniqueMiniTitle">
              WHAT TO EXPECT
            </span>

            <h2 className="wteUniqueHeading">
              What to Expect with <span>Indiaboats</span>
            </h2>

            <p className="wteUniqueParagraph">
              When you plan an Alibaug or Elephanta boat tour with
              Indiaboats, the experience is designed to feel premium,
              comfortable and easy to organise. We help guests understand
              which boat format suits their group size, route and travel
              need so the overall journey feels efficient, scenic and
              enjoyable.
            </p>
          </div>

          <div className="wteUniqueRightContent">
            {wteExperiencePoints.map((item, index) => (
              <div className="wteUniqueListCard" key={index}>
                <div className="wteUniqueCheckCircle">✓</div>

                <p className="wteUniqueListText">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

     <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
            At Indiaboats, safety is central to every private boat
            experience. We place strong emphasis on trained crew,
            responsible operations, guest comfort and smooth coordination
            so your Alibaug or Elephanta boat tour feels enjoyable,
            comfortable and professionally managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  pageKey="Alibaug"
  title="Frequently Asked Questions About Alibaug & Elephanta Boat Tours"
  faqData={alibaugElephantaFaqs}
/>

 <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

          <span className="igxMiniTag">
            FINAL CTA
          </span>

          <h2 className="igxMainHeading">
            Plan an Island Getaway That Feels
            <span> Effortless and Memorable</span>
          </h2>

          <p className="igxParagraphText">
            Discover how a private boat tour from Mumbai to
            Alibaug or Elephanta can turn a simple trip into
            a scenic and premium coastal experience with
            Indiaboats.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Plan Your Boat Tour</span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Explore Speed Boat Transfers</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Enquire on WhatsApp</span>
            </button>

          </div>
        </div>
      </div>
    </section>

     <section className="btfUniqueSection">
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Boat Tour Requirement</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">

            <div className="btfUniqueInputGrid">

              <div className="btfUniqueFieldBox">
                <label>Name</label>
                <input type="text" placeholder="Enter your name" />
              </div>

              <div className="btfUniqueFieldBox">
                <label>Mobile Number</label>
                <input type="tel" placeholder="Enter mobile number" />
              </div>

              <div className="btfUniqueFieldBox">
                <label>Email Address</label>
                <input type="email" placeholder="Enter email address" />
              </div>

              <div className="btfUniqueFieldBox">
                <label>Preferred Date</label>
                <input type="date" />
              </div>

              <div className="btfUniqueFieldBox">
                <label>Number of Guests</label>
                <input type="number" placeholder="Number of guests" />
              </div>

              <div className="btfUniqueFieldBox">
                <label>Destination</label>

                <select>
                  <option>Select destination</option>
                  <option>Alibaug</option>
                  <option>Elephanta</option>
                </select>
              </div>

            </div>

            <div className="btfUniqueFieldBox btfUniqueTextareaBox">
              <label>Requirement Details</label>

              <textarea
                rows="6"
                placeholder="Tell us more about your travel requirement..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="btfUniqueSubmitButton"
            >
              <span>Enquire Now</span>
            </button>

          </form>
        </div>
      </div>
    </section>

            </div>


<Footer/>
</>
  )
}

export default Alibaug
